import { darkEffect, flex, breakpoints } from "./styles/utils";
import styled from "styled-components";

export const Container = styled.div`
  ${flex("column")}
  bottom: 1.5rem;
  right: 3rem;
  position: fixed;
  width: 375px;

  @media (max-width: ${breakpoints.tablet}) {
    bottom: 1.5rem;
    right: 1.5rem;
  }
`;

type Props = {
  open?: boolean;
};

export const ButtonContainer = styled.div<Props>`
  ${darkEffect}
  ${flex("row", "center", "center")}
  align-self:end;
  border-radius: 100px;
  height: 56px;
  width: 56px;
  pointer-events: ${(props) => (props.open ? "none" : "")};
`;

export const Title = styled.h2<{ $textColor?: string }>`
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0em;
  color: ${(props) => props.$textColor || "var(--black)"};
`;

export const Text = styled.p<{ $textColor?: string }>`
  font-size: 1rem;
  font-weight: 400;
  line-height: 23px;
  letter-spacing: 0em;
  margin-top: 10px;
  color: ${(props) => props.$textColor || "var(--black)"};
`;

export const SelectorOptionsContainer = styled.div`
  ${flex("column")}
  gap: 10px;
  padding: 20px 0;

  a {
    text-decoration: none;
  }

  button {
    border: none;
    border-radius: 8px;
    background: transparent;
  }
`;

export const SelectorOption = styled.div`
  ${flex("row", "center", "space-between")}
  ${darkEffect}
  background: var(--white);
  color: black;
  border-radius: 8px;
  padding: 12px;
  width: 100%;

  h3 {
    font-size: 0.81rem;
    font-weight: 700;
    letter-spacing: 0em;
    text-align: left;
    line-height: 1.4;
    margin-bottom: 10px;
    margin-right: 10px;
  }

  p {
    font-size: 0.75rem;
    font-weight: 300;
    letter-spacing: 0em;
    text-align: left;
    line-height: 1.4;
    margin-right: 10px;
  }
`;
